import { render, staticRenderFns } from "./point-detail.vue?vue&type=template&id=448a46b6&scoped=true&"
import script from "./point-detail.vue?vue&type=script&lang=js&"
export * from "./point-detail.vue?vue&type=script&lang=js&"
import style0 from "./point-detail.vue?vue&type=style&index=0&id=448a46b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448a46b6",
  null
  
)

export default component.exports